<template>
    <a
        :class="{
            'patsnap-biz-tag_legal': true,
            'patsnap-biz-tag_legal--simple': simple,
            'patsnap-biz-tag_legal--plain':isPlain,
            [`patsnap-biz-tag_legal--code_${code}`]: true
        }"
    >
        {{ text }}
    </a>
</template>

<script>
import { getLegalMessage } from '@patsnap-utils/biz';

export default {
    name: 'PtTagLegal',
    props: {
        /**
         * 法律状态或法律事件状态码
         */
        code: {
            type: [Number, String],
            required: true,
        },
        /**
         * 是否简单法律状态
         */
        simple: {
            type: Boolean,
            default: false,
        },
        /**
         * 法律状态是否是plain
         */
        isPlain: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        text() {
            return getLegalMessage(this.code, this.simple, this.$i18n.locale)
                || this.$t(`PtTagLegal.${this.simple ? 'simple' : 'legal'}.${this.code}`);
        },
    },
};
</script>
